import AppStoreImage from "@/assets/images/appStore.svg";
import FacebookIcon from "@/assets/images/facebook.svg";
import GooglePlayImage from "@/assets/images/googlePlay.svg";
import LinkedInIcon from "@/assets/images/linkedin.svg";
import TwitterIcon from "@/assets/images/twitter.svg";
import YoutubeIcon from "@/assets/images/youtube.svg";
import { Storage, TermsAndConditionsLang } from "@/shared/common/enums";
import { getFromLocalStorage } from "@/shared/helpers";
import { Image } from "@ab.uitools/ui-library/components/Image";
import { Link } from "@ab.uitools/ui-library/components/Link";
import { Text } from "@ab.uitools/ui-library/components/Text";
import { config } from "app/config";
import { useTranslation } from "react-i18next";

export const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const lang = getFromLocalStorage(Storage.Lang) as keyof typeof TermsAndConditionsLang;
  const termsAndConditionsUrl = `${config.termsAndConditionsUrl}${TermsAndConditionsLang[lang]}.pdf`;

  return (
    <div data-testid="app-footer" className="footer">
      <div className="flexbox justify-content--between full-width pb-16 footer__top">
        <div className="flexbox">
          <Link
            className="terms-conditions-link"
            url={termsAndConditionsUrl}
            target="_blank"
          >
            <Text
              className="pt-6 pb-6"
              lineHeight="small"
              type="tertiary"
              size="standard"
              data-testid="terms-and-conditions"
            >
              {t("footer.termsAndConditions")}
            </Text>
          </Link>
        </div>

        <div className="flexbox contact">
          <Text
            className="pt-6 pb-6"
            type="tertiary"
            lineHeight="small"
            size="standard"
            data-testid="tel-number"
          >
            +374 10 56 11 11
          </Text>

          <Text
            className="ml-16 pt-6 pb-6"
            lineHeight="small"
            type="tertiary"
            size="standard"
            data-testid="info-email"
          >
            info@ameriabank.am
          </Text>
        </div>
      </div>
      <div className="pt-16 footer__bottom">
        <div data-testid="social-icons" className="flexbox">
          <Link className="icon-wrapper">
            <Image imagePath={FacebookIcon}/>
          </Link>
          <Link className="icon-wrapper ml-24">
            <Image imagePath={LinkedInIcon}/>
          </Link>
          <Link className="icon-wrapper ml-24">
            <Image imagePath={TwitterIcon}/>
          </Link>
          <Link className="icon-wrapper ml-24">
            <Image imagePath={YoutubeIcon}/>
          </Link>
        </div>
        <div
          data-testid="market-icons"
          className="flexbox justify-content--end store-section-mobile"
        >
          <Link>
            <Image imagePath={AppStoreImage}/>
          </Link>
          <Link className="ml-16">
            <Image imagePath={GooglePlayImage}/>
          </Link>
        </div>
        <div className="flexbox flex-direction--column align-items--center copyright-section">
          <Text
            className="mb-4"
            lineHeight="small"
            type="tertiary"
            size="standard"
            data-testid="ameriabank-cjsc"
          >
            © {currentYear} Ameriabank CJSC
          </Text>
          <Text
            type="tertiary"
            lineHeight="small"
            size="xsmall"
            className="bank-control-text"
            data-testid="control-text"
          >
            {t("footer.bankControlledByCentralBank")}
          </Text>
        </div>
        <div
          data-testid="market-icons"
          className="flexbox justify-content--end store-section-desktop">
          <Link>
            <Image imagePath={AppStoreImage}/>
          </Link>
          <Link className="ml-16">
            <Image imagePath={GooglePlayImage}/>
          </Link>
        </div>
      </div>
    </div>
  );
};
